import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { existsFilter } from '@iotv/core-services';
import { Area } from '@iotv/datamodel-core';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useEffect } from 'react';
import { v4 } from 'uuid';
import { getAreaPlaceQuery } from '../../../QueryDefinitions';
import { ConsumerDao } from '../../../data/ConsumerDAO/consumerDAO';
import { useTabHandlerStringKeys } from '../../../hooks/useTabHandler';
import { AdjacentType, Severity } from '../../../types/AppTypes';
import { ObjectHeader } from '../../../v2/components/generic/ObjectView/ObjectHeader';
import { AutoTab } from '../AutoTab';
import { getAreaViewDefinition, getPlaceViewDefinition } from '../viewDefinitions';
import { AreaDetailCard } from './AreaDetail';
import { AreaPointsTab } from './AreaPointsTab';
import { KMLImportTab } from './KMLImportTab';
const debug = process.env.REACT_APP_DEBUG && false;
export const AreaView = (props) => {
    const { viewObject: viewContext, transactionFunctions, userFunctions, applicationData, contextCustomer, allowedActions } = props;
    const contextArea = viewContext.matchedPrimary ? new Area(viewContext.matchedPrimary) : undefined;
    /** Load everything to do with areas - places, child areas, entity groupes (if any) */
    const getAreaContext = async () => {
        if (!contextArea)
            return;
        const { err, data } = await ConsumerDao.getGraphQueryRequestV2({ contextObjects: [contextArea], query: getAreaPlaceQuery() });
        if (err) {
            userFunctions.setUserMessage({ content: `${err.message}`, id: v4(), label: '', type: 'MessageBar', severity: Severity.error });
        }
        if (data) {
            debug && console.log('getAreaContext returned', data.getContainedNodesAndEdges());
            debug && console.log('getAreaContext nem has context object', !!data.getItem(contextArea), data.getItem(contextArea));
            userFunctions.addObjectsToState(data.getContainedNodesAndEdges());
        }
    };
    useEffect(() => {
        getAreaContext();
    }, [contextArea?.sk]);
    debug && console.log('AreaView applicationData', applicationData);
    const tabDefs = [
        {
            label: 'Details',
            value: 'Details',
            component: contextArea ? _jsx(AreaDetailCard, { ...props, contextArea: contextArea }) : _jsx(_Fragment, {}),
        },
        { direction: AdjacentType.CHILD, label: 'Areas', value: 'Areas', type: 'Area' },
        { direction: AdjacentType.CHILD, label: 'Places', value: 'Places', type: 'Place' },
        contextArea && contextArea.points.length
            ? {
                label: 'Points',
                value: 'Points',
                component: contextArea ? _jsx(AreaPointsTab, { contextArea: contextArea, userFunctions, viewOnly: allowedActions?.edit !== true }) : _jsx(_Fragment, {}),
            }
            : null,
        {
            label: 'KML Import',
            value: 'kmlImport',
            component: contextArea ? (_jsx(KMLImportTab, { contextObject: contextArea,
                userFunctions,
                childAreas: applicationData?.getChildNodes(contextArea).filter((n) => n.type === 'Area'),
                childPlaces: applicationData?.getChildNodes(contextArea).filter((n) => n.type === 'Place'),
                viewOnly: allowedActions?.edit !== true })) : (_jsx(_Fragment, {})),
        },
    ];
    const tabKeyMap = Object.fromEntries(tabDefs.filter(existsFilter).map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    const typesToViewDefs = {
        Area: getAreaViewDefinition(),
        Place: getPlaceViewDefinition(),
    };
    return (_jsxs(_Fragment, { children: [_jsx(ObjectHeader, { vob: contextArea }), _jsxs(TabContext, { value: value, children: [_jsx(TabList, { value, onChange: handleTabChange, children: tabDefs.filter(existsFilter).map((t) => (_jsx(Tab, { label: t.label, value: t.value, sx: { textTransform: 'none' } }, t.value))) }), tabDefs.filter(existsFilter).map((t) => {
                        const tabContent = contextArea && (_jsx(AutoTab, { tabDef: t,
                            mostProximateCustomer: contextCustomer,
                            contextCustomer,
                            contextObject: contextArea,
                            viewObject: viewContext,
                            userFunctions,
                            transactionFunctions,
                            viewDefinitionIn: typesToViewDefs[t.type ?? ''],
                            newObjectDefinition: typesToViewDefs[t.type ?? ''] }));
                        return (_jsx(TabPanel, { value: t.value, sx: { padding: 0, paddingBlockStart: 1 }, children: tabContent }, t.value));
                    })] })] }));
};
